import { ListSubheader, Box, Chip, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, InputLabel, MenuItem, OutlinedInput, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { isFeuilleDeMatchFull } from "../../../../../../components/Live/utils/feuilleMatch.js";
import { useCallback, useMemo, useState } from "react";
import { useTheme } from "@emotion/react";
import { Edit as EditIcon } from '@mui/icons-material';
import { notation_custoquestion_all } from "../../../../../../bdd/bddSTUB.js";
import useStyles from '../../../../../../styles/global-mui.js';
import DsasButton from "../../../../../components/DsasButton/DsasButton.js";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
}

const SelectNotation = ({event, onChange, directEvent}) => {
    const theme = useTheme();

    const {globalTarget, preciseTarget, exactTarget} = event

    const [isEditMode, setIsEditMode] = useState(false);

    const classes = useStyles();

    const handleEditModeToggle = () => {
      setIsEditMode(!isEditMode);
      onChange("customQuestion", '')
    };

    const targetList = useMemo(() => {
      if (!globalTarget || globalTarget === "match") return [];
    
      const isHome = globalTarget === directEvent.homeTeam._id;
      const teamLabel = isHome ? "home" : "away";
    
      const team = directEvent[`${teamLabel}Team`];
      const holders = directEvent[`${teamLabel}Holders`] || [];
      const substitutes = directEvent[`${teamLabel}Substitutes`] || [];
      const allPlayers = team?.players || [];
    
      const others = allPlayers.filter(
        (p) =>
          !holders.some((h) => h._id === p._id) &&
          !substitutes.some((s) => s._id === p._id)
      );
    
      const sortPlayers = (players) =>
        players.slice().sort((a, b) => {
          if (a.numero !== b.numero) return a.numero - b.numero;
          return a.lastname.localeCompare(b.lastname);
        });
    
      return [
        { label: "Titulaires", players: sortPlayers(holders) },
        { label: "Remplaçants", players: sortPlayers(substitutes) },
        ...(others.length > 0 ? [{ label: "Autres", players: sortPlayers(others) }] : [])
      ].filter(p => p.players.length);
    }, [globalTarget, directEvent]);   



        if(directEvent.type==='actu')
            return (
              <div className="survey-form">
                <Box className='centered-wrapper'>
                        <Typography variant='body1' fontWeight="bold" gutterBottom>Question personnalisée</Typography>
                        </Box>
                <Grid container gap={1.5} pt={2}>
                   
                  <Grid item xs>
                      {isEditMode ? ( <Box>
                       
                        <Box className='centered-wrapper'>
                        <TextField
                          type="text"
                          className={classes.customInput}
                          placeholder="Saisir la question"
                          fullWidth
                          multiline
                          minRows={1}
                          maxRows={3}
                          value={event.customQuestion || ""}
                          onChange={(e) => onChange("customQuestion", e.target.value)}
                        />
                        </Box></Box>
                    ) : (
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              className={classes.customInput}
                            >
                              <InputLabel id="question" shrink>Question</InputLabel>

                              <Select
                                labelId="question"
                                id="question"
                                name="customQuestion"
                                value={event.customQuestion || ''}
                                label="Question"
                                fullWidth
                                onChange={(e) => onChange("customQuestion", e.target.value)}
                                displayEmpty
                                renderValue={(selected) => {
                                  const selectedItem = notation_custoquestion_all.find(i => i._id === selected);
                                  if (!selectedItem) {
                                    return <em style={{ color: '#aaa' }}>Sélectionner une question par défaut</em>;
                                  }
                                  const text = selectedItem.name || `${selectedItem.lastname} ${selectedItem.firstname}`;
                                  return (
                                    <Box sx={{ whiteSpace: 'normal', lineHeight: '1.2em' }}>
                                      {text}
                                    </Box>
                                  );
                                }}
                                sx={{
                                  '& .MuiSelect-select': {
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                    lineHeight: 1.3,
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                    minHeight: event.customQuestion ? '3.5em' : '2.5em', // ✅ réduit la hauteur si aucune sélection
                                    display: 'flex',
                                    alignItems: 'center',
                                  },
                                }}
                                MenuProps={{
                                  PaperProps: {
                                    sx: {
                                      maxHeight: 300,
                                    },
                                  },
                                }}
                              >
                                {/* Option vide pour permettre la sélection par défaut */}
                                <MenuItem disabled value="">
                                  <em>Sélectionner une question par défaut</em>
                                </MenuItem>

                                {notation_custoquestion_all?.map(i => {
                                  const text = i.name || `${i.lastname} ${i.firstname}`;
                                  return (
                                    <MenuItem
                                      key={i._id}
                                      value={i._id}
                                      sx={{
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word',
                                        lineHeight: '1.2em'
                                      }}
                                    >
                                      {text}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>

                    )}
                    </Grid>

                    <Grid item md={12} lg={2} sx={{justifyItems:'center', alignItems:'center', textAlign:'center'}}>
                      <Box className='centered-wrapper'
                      sx={{    display: 'flex',
                                alignContent: 'space-around',
                                flexDirection: 'column',
                                flexWrap: 'nowrap',
                                height: '100%'}}
                      >
                          <DsasButton onClick={handleEditModeToggle} variant='secondary' icon={faEdit}>
                      </DsasButton>
                      </Box>
                    </Grid>

                </Grid>
              </div>
            )
    

    return (
        <div className="survey-form">
          <Box className='centered-wrapper'>
            <Typography variant='body1' fontWeight="bold" gutterBottom>Configuration</Typography>
          </Box>
          <Box className='small-padding'>
            <FormControl fullWidth >
            <FormLabel id="demo-controlled-radio-buttons-group" className={classes.customInputLabel}>Que doit-on noter ?</FormLabel>
            <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={globalTarget}
            onChange={(e) => {onChange("globalTarget", e.target.value)}}
            >
                <Grid>
                    <FormControlLabel value={'match'} control={<Radio />} label={'Match'} />
                    <FormControlLabel value={directEvent.homeTeam._id} control={<Radio />} label={directEvent.homeTeam.name} />
                    <FormControlLabel value={directEvent.awayTeam._id} control={<Radio size="small" />} label={directEvent.awayTeam.name} />
                </Grid>
            </RadioGroup>
        </FormControl>
        </Box>
        {/* <Divider variant="inset" /> */}
        {globalTarget && globalTarget!=='match' && 
        <Box className='small-padding'>
        <FormControl fullWidth >
            <FormLabel id="demo-controlled-radio-buttons-group" className={classes.customInputLabel}> Plus précisément ?</FormLabel>
            <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={preciseTarget}
            onChange={(e) => {onChange("preciseTarget", e.target.value)}}
            >
                <Grid>
                    <FormControlLabel value={'team'} control={<Radio />} label={'Equipe'} />
                    <FormControlLabel value={'players'} control={<Radio />} label={'Joueur(s)'} />
                    <br/>
                    {preciseTarget === 'players' && 
                        <FormControl sx={{ m: 1}} fullWidth>
                        <InputLabel id="demo-multiple-chip-label">Joueurs</InputLabel>
                        <Select
                          multiple
                          value={exactTarget}
                          onChange={(e) => {
                            const { value } = e.target;
                            onChange("exactTarget", typeof value === "string" ? value.split(',') : value);
                          }}
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {selected.map((value) => {
                                const player = targetList.flatMap(g => g.players).find(p => p._id === value);
                                return <Chip key={value} label={player?.lastname ?? value} />;
                              })}
                            </Box>
                          )}
                        >
                          {targetList.map((group, index) => [
                            <ListSubheader key={`subheader-${index}`}>{group.label}</ListSubheader>,
                            ...group.players.map((player) => (
                              <MenuItem key={player._id} value={player._id}>
                                {player.numero ? `${player.numero} - ` : ""}
                                {player.lastname.toUpperCase()} {player.firstname}
                              </MenuItem>
                            )),
                          ])}
                        </Select>
                      </FormControl>
                      
                        }
                        
                </Grid>
            </RadioGroup>
        </FormControl>
        </Box>
        }
        </div>
        );

}

export default SelectNotation